export const secrets = {
  REACT_APP_ENV: '${REACT_APP_ENV}',
  apikey: '${apikey}',
  clientId: '${clientid}',
};
